import React, { Component } from 'react';
import { Alert, FormGroup, Container, Row, Col, Card, CardBody, Button, InputGroup, } from 'reactstrap';
import { ReduxInput } from '../../components/ReduxInput';
import { Link } from 'react-router-dom';
import { Form, Field, reduxForm } from 'redux-form';
import { isValidEmail, isRequired, passwordCheck, passwordVerify } from '../../components/ReduxInput/Validators';
import DashboardLogoGroup from '../../components/DashboardLogoGroup';
import Waitable from '../../components/Waitable';

class Register extends Component {
  render() {
    const { success, errorText, registration } = this.props;
    const lower = value => value && value.toLowerCase()
    return (
      <div>
        <Row>
          <DashboardLogoGroup />
        </Row>
        <div className="app flex-row  animated fadeIn  mt-5 pt-5">

          <Container>
            <Waitable entities={[registration]}>
              <Form onSubmit={this.props.handleSubmit}>
                <Row className="justify-content-center">
                  <Col md="6">
                    <Card className="mx-4">
                      <CardBody className="p-4">
                        <FormGroup className="mb-4">
                          {success ? <Alert color="success">
                            <p className="text-center" >Thank you for your registration, please check your inbox to confirm your email address and get started.</p>
                          </Alert> : null}

                          {errorText ? <Alert id="errorAlert" className="animated shake" color="danger">
                            <p className="text-center" >{errorText}</p>
                          </Alert> : null}
                        </FormGroup>
                        <h1>Register</h1>
                        <p className="text-muted">Create your account</p>
                        {/*
                        <InputGroup className="mb-4">
                          <Field
                          id="invitationCode"
                            name="invitationCode"
                            validate={[isRequired]}
                            iconClass="fa fa-key" type="text" placeholder="Invitation Code" component={ReduxInput} />
                        </InputGroup>
                        */}
                        <InputGroup className="mb-3">
                          <Field
                          id="organization"
                            name="organization"
                            validate={[isRequired]}
                            iconClass="fa fa-building-o" type="text" placeholder="Organization Name" component={ReduxInput} />
                        </InputGroup>
                        <InputGroup className="mb-3">
                          <Field iconClass="fa fa-envelope-o"
                          id="email"
                          name="email"
                            validate={[isRequired, isValidEmail]}
                            normalize={lower}
                            type="text" placeholder="Email" component={ReduxInput} />
                        </InputGroup>
                        <InputGroup className="mb-3">
                          <Field iconClass="fa fa-lock"
                          id="password"
                            validate={[isRequired, passwordCheck]}
                            name="password" type="password" placeholder="Password" component={ReduxInput} />
                        </InputGroup>
                        <InputGroup className="mb-4">
                          <Field iconClass="fa fa-lock"
                            validate={[isRequired, passwordCheck, passwordVerify]}
                            name="confirm"
                            id="confirm"
                            type="password" placeholder="Repeat password" component={ReduxInput} />
                        </InputGroup>
                        <Row>
                          <Col md="6">
                            <InputGroup className="mb-4">
                              <Field iconClass="fa fa-user-o"
                                validate={[isRequired]}
                                id="firstName"
                                name="firstName"
                                type="text" placeholder="First Name" component={ReduxInput} />
                            </InputGroup>
                          </Col>
                          <Col md="6">
                            <InputGroup className="mb-4">
                              <Field iconClass="fa fa-user-o"
                                validate={[isRequired]}
                                id="lastName"
                                name="lastName"
                                type="text" placeholder="Last Name" component={ReduxInput} />
                            </InputGroup>
                          </Col>
                        </Row><Row>
                          <Col xs="6">
                            <Button id="register" type="submit" color="primary" className="px-4">Register</Button>
                          </Col>
                          <Col xs="6" className="text-right">
                            Registered?
                      <Link to="/login" id="goBack" > Go to Login</Link>
                          </Col>
                        </Row>
                      </CardBody>
                    </Card>
                  </Col>

                </Row>
              </Form>
            </Waitable>
          </Container>
        </div >
      </div>
    );
  }
}
export default reduxForm({
  form: "Register",   // a unique identifier for this form
  destroyOnUnmount: false,         // preserve form data
  forceUnregisterOnUnmount: true,  // unregister fields on unmount
})(Register);






// WEBPACK FOOTER //
// ./src/views/Register/Register.js